const $teaserMain = $('#teaser-main');
$teaserMain.slick({
  lazyLoad: 'ondemand',
  centerMode: true,
  variableWidth: true,
  slidesToShow: 3
});